export function isProb3() {
	return window.location.origin.includes('pro');
}
